<template>
  <v-card flat color="transparent">
    <!-- Horizontal layout for breakpoints of sm and down -->
    <div class="hidden-md-and-up">
      <v-card-title class="px-0 py-2">
        <h2 class="text-break homepageTitle mb-1">
          {{ title }}
        </h2>
      </v-card-title>

      <v-card-text style="overflow-x: auto" class="px-0">
        <v-row class="flex-nowrap flex-md-wrap ma-0" dense>
          <!-- list of events -->
          <template v-for="(event, index) in events">
            <v-col :key="index" cols="9" sm="5" md="12" class="px-0 pr-2">
              <v-hover v-slot="{ hover }">
                <v-card
                  color="grey lighten-5"
                  class="rounded-lg"
                  :elevation="hover ? 5 : 1"
                  @click="onEventClick(event)"
                >
                  <!-- image of the event -->
                  <v-img
                    :aspect-ratio="1.618 / 1"
                    :src="event.PictureUrl"
                    class="trendingProductImage clickableCard"
                  >
                    <!-- ranking of the event -->
                    <v-avatar class="ma-2" color="primary" size="25">
                      <span class="primary-font-color text-button">
                        <b style="font-size: 15px">{{ index + 1 }}</b>
                      </span>
                    </v-avatar>
                  </v-img>

                  <!-- event name -->
                  <v-card-title class="pa-2">
                    <div
                      class="col pa-1 blue-grey--text text--darken-4 itemTitleFontSize text-center font-weight-bold text-truncate"
                    >
                      {{ event.Name }}
                    </div>
                  </v-card-title>
                </v-card>
              </v-hover>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </div>

    <!-- Vertical layout for breakpoints of md and up -->
    <div class="hidden-sm-and-down">
      <v-row justify="center" align="center">
        <v-col cols="11">
          <v-card color="primary" elevation="1" tile>
            <v-card-text class="px-3 py-2">
              <h3
                class="primary-font-color homepageSubTitle text-h6 font-weight-bold text-break"
              >
                {{ $translate('TRENDING') }}
              </h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card-text
        class="px-4 pt-0 mt-3"
        :style="`max-height: 1200px; overflow-y: auto;`"
      >
        <v-list two-line color="transparent">
          <template v-for="(event, index) in events">
            <v-list-item
              :key="`event-${index}`"
              class="px-0"
              @click="onEventClick(event)"
            >
              <!-- Picture, visible for lg and up breakpoints -->
              <v-list-item-avatar rounded class="hidden-md-only">
                <v-img :src="event.PictureUrl" />
              </v-list-item-avatar>

              <v-list-item-content>
                <!-- Picture, visible for md and down breakpoints -->
                <v-avatar rounded size="80" class="hidden-lg-and-up mb-2">
                  <v-img :src="event.PictureUrl" />
                </v-avatar>

                <!-- Name -->
                <v-list-item-title v-html="event.Name" />

                <!-- Description -->
                <v-list-item-subtitle v-html="event.Subtitle" />
              </v-list-item-content>
            </v-list-item>

            <v-divider
              v-if="index < events.length - 1"
              :key="`divider-${index}`"
              inset
            />
          </template>
        </v-list>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import trendingEventsMixin from '@/mixins/trendingEvents';

export default {
  name: 'TrendingEvents',
  mixins: [trendingEventsMixin],
};
</script>
